import { useContext, useMemo } from 'react';
import { customerClaim, canonicalIDClaim, cimpressInternalClaim, anonymousClaim, wasClaim } from './constants';
import { IdentityContext } from './IdentityProvider';
import { hasValidCanonicalId } from './utils';
export const useIdentityContext = () => {
    const context = useContext(IdentityContext);
    if (context === undefined) {
        throw new Error(`Use of useIdentityContext() must be wrapped inside a <IdentityProvider />`);
    }
    const { isIdentityInitialized, identity, auth, ownerId, shouldBeCareAgent } = context;
    let isSignedIn = false;
    let isShopper = false;
    let isCareAgent = false;
    let isAnonymousUser = false;
    let shopperId = '';
    let anonymousUserId = '';
    let cimpressADFSUserId = '';
    let was = '';
    if (isIdentityInitialized && identity) {
        if (identity.isSignedIn) {
            isSignedIn = true;
            if (identity.profile) {
                // Shopper
                if (identity.profile[customerClaim]) {
                    shopperId = identity.profile[canonicalIDClaim];
                    isShopper = true;
                }
                const validCanonicalId = hasValidCanonicalId(identity.profile[canonicalIDClaim]);
                // Internal JWT
                if (identity.profile[cimpressInternalClaim] || (validCanonicalId && !isShopper)) {
                    cimpressADFSUserId = identity.profile[canonicalIDClaim];
                    // Care Agent
                    if (shouldBeCareAgent) {
                        shopperId = ownerId || '';
                        isCareAgent = true;
                    }
                }
            }
        }
        // Anonymous
        if (identity.profile && identity.profile[anonymousClaim]) {
            isSignedIn = identity.isSignedIn;
            isAnonymousUser = true;
            anonymousUserId = identity.profile[canonicalIDClaim];
        }
        was = identity.profile && identity.profile[wasClaim] ? identity.profile[wasClaim].join(',') : '';
    }
    const memoizedIdentity = useMemo(() => {
        return {
            isSignedIn,
            isShopper,
            isCareAgent,
            isAnonymousUser,
            shopperId,
            anonymousUserId,
            cimpressADFSUserId,
            was,
        };
    }, [isSignedIn, isShopper, isCareAgent, isAnonymousUser, shopperId, anonymousUserId, cimpressADFSUserId, was]);
    return {
        isIdentityInitialized,
        identity: memoizedIdentity,
        auth,
    };
};
//# sourceMappingURL=useIdentityContext.js.map